import Handlebars from "handlebars/dist/handlebars";

Handlebars.registerPartial('app_company_service_list_partial', $('#app_company_service_list_partial').html());